import {TokenStore} from '../Services/security/TokenStore';

export const checkAuthStatus = () => {
  const token = TokenStore.getAccessToken();
  const refreshToken = TokenStore.getRefreshToken();
  return {
    hasAuthToken: !!token,
    hasRefreshToken: !!refreshToken,
    token,
    refreshToken
  };
};

export const clearAuthTokens = () => {
  TokenStore.clear();
};
